// Denúncias das Mensagens (0.73): exigência da Apple (regra 1.2) para conteúdo feito pelos usuários.
// Vai para a tabela "denuncias" do servidor (só a equipe lê). Se o servidor ainda não tiver a tabela,
// a denúncia segue pelo Fale conosco (e, sem internet, pelo e-mail do suporte), para nunca se perder.
import { supabase } from './supabase';
import { DEMO } from './env';
import { enviarFeedback, feedbackPorEmail } from './indicacao';
import { resumoDe, type Mensagem } from './chat';

export type MotivoDenuncia = 'spam' | 'assedio' | 'improprio' | 'outro';
export type AlvoDenuncia = {
  usuario?: string | null;   // pessoa denunciada (autor da mensagem ou o contato)
  nome?: string;             // nome que aparece na tela (contato, grupo ou autor)
  conversa?: string | null;
  mensagem?: Mensagem | null;
  grupo?: boolean;           // denúncia do grupo inteiro
};

const rotulo: Record<MotivoDenuncia, string> = { spam: 'Spam', assedio: 'Assédio ou ameaça', improprio: 'Conteúdo impróprio', outro: 'Outro' };

/** Envia a denúncia. 'ok' = gravada no servidor; 'suporte' = foi pelo Fale conosco; 'email' = abriu o e-mail. */
export async function enviarDenuncia(alvo: AlvoDenuncia, motivo: MotivoDenuncia, detalhe: string): Promise<'ok' | 'suporte' | 'email'> {
  const m = alvo.mensagem;
  const trecho = m ? (m.tipo === 'texto' ? m.texto : resumoDe(m)).slice(0, 500) : null;
  const motivoTxt = (motivo + (detalhe.trim() ? ': ' + detalhe.trim() : '')).slice(0, 1000);
  if (DEMO) return 'ok';
  if (supabase) {
    const { error } = await supabase.from('denuncias').insert({
      alvo_usuario: alvo.usuario ?? m?.autor ?? null,
      conversa_id: alvo.conversa ?? m?.conversa_id ?? null,
      mensagem_id: m?.id ?? null,
      trecho,
      motivo: motivoTxt,
    });
    if (!error) return 'ok';
  }
  // reserva: Fale conosco (o mesmo envio de Ajustes > Fale conosco)
  const texto = [
    '🚩 DENÚNCIA (Mensagens)',
    `Motivo: ${rotulo[motivo]}${detalhe.trim() ? ' · ' + detalhe.trim() : ''}`,
    alvo.grupo ? `Grupo: ${alvo.nome ?? ''}` : `Pessoa: ${alvo.nome ?? ''} (${alvo.usuario ?? m?.autor ?? '?'})`,
    `Conversa: ${alvo.conversa ?? m?.conversa_id ?? '-'}`,
    m ? `Mensagem ${m.id}: ${trecho}` : '',
  ].filter(Boolean).join('\n');
  try {
    return (await enviarFeedback('problema', texto, '')) === 'ok' ? 'suporte' : 'email';
  } catch {
    await feedbackPorEmail('problema', texto);
    return 'email';
  }
}
